const API_ENDPOINT_CONSTANTS = {
  ADVERTISEMENT_CREATE: "w/ad/create",
  ADVERTISEMENT_DELETE: "w/ad/delete",
  ADVERTISEMENT_LIST: "w/ad/list",
  ADVERTISEMENT_MEDIA: "w/ad/media",
  ADVERTISEMENT_UPDATE: "w/ad/update",
  DROPDOWN: "w/dropdown/",
  EVENT_CREATE: "w/event/create",
  EVENT_DELETE: "w/event/delete",
  EVENT_LIST: "w/event/list",
  EVENT_UPDATE: "w/event/update",
  LOGIN: "public/login",
  LOGOUT: "public/logout",
  MEMBERS: "w/members",
  MEMBER_CREATE: "w/member/create",
  MEMBER_DELETE: "w/member/delete",
  MEMBER_DELETE_CANCEL: "w/member/delete/cancel",
  MEMBER_TRANSFER_HEAD: "w/member/delete/transferHead",
  MEMBER_TRANSFER_HEAD_RELATION: "w/member/delete/transferHeadRltn",
  MEMBER_STATUS: "w/member/status",
  MEMBER_TEMP: "w/memberTemp",
  MEMBER_UPDATE: "w/member/update",
  MENU: "bulk/menu",
  MENUS: "w/menus",
  OPERATION_USER: "w/operationUser",
  OPERATION_USERS: "w/operationUsers",
  ROLE: "w/role",
  ROLES: "w/roles",
};

export default API_ENDPOINT_CONSTANTS;
